import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { Controller, useForm } from 'react-hook-form';
import { $cardStore } from '@lib/store';
import { BaseInput, Button, ErrorMessage, Modal, Text } from '@shared/widgets';

interface IForm {
  password: string;
}
const DEFAULT_VALUES: IForm = { password: '' };

interface RequestPinModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const RequestPinModal = (props: RequestPinModalProps) => {
  const cardStore = useUnit($cardStore.store);

  const { t } = useTranslation('card');

  const { control, formState, handleSubmit, reset } = useForm<IForm>({ defaultValues: DEFAULT_VALUES });

  const closeHandler = () => {
    props.onClose();
    reset(DEFAULT_VALUES);
  };
  const submitHandler = async (data: IForm) => {
    await $cardStore.events.remindPin({ cardId: cardStore.data!.cardId, password: data.password });
    closeHandler();
  };

  return (
    <Modal isOpen={props.isOpen} onClose={closeHandler} loading={cardStore.actionLoading} title={t('sidebar.modals.requestPin.title')}>
      <form className='flex flex-col gap-5' noValidate onSubmit={handleSubmit(submitHandler)}>
        <Controller
          name='password'
          control={control}
          rules={{ required: t('errors.form.required', { ns: 'common' }) }}
          render={({ field, fieldState: { error } }) => (
            <div>
              <BaseInput {...field} type='password' placeholder={t('placeholders.password', { ns: 'common' })} required />
              <ErrorMessage text={error?.message} />
            </div>
          )}
        />
        <Text weight='light' size='xs'>
          {t('sidebar.modals.requestPin.description', {
            mobileNumber: `+${cardStore.data?.mobileAreaCode || ''}${cardStore.data?.mobileNumber || ''}`,
          })}
        </Text>
        <Button fullWidth color='primary' type='submit' disabled={formState.isSubmitting}>
          {t('sidebar.modals.requestPin.buttons.requestPin')}
        </Button>
      </form>
    </Modal>
  );
};
